import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/694efc4e66cdef001448ba8b/new_capital_epc/src/app/landing-page/components/LandingPageInteractive.tsx");
